import TextField from '../../../../../../primitives/form/TextField/TextField';

export function LoadingApiPlaceholder(props) {
  const { layout } = props;

  switch (layout) {
    case 'editFormTemplate':
      return (
        <>
          <div className="form-template-header__title-section">
            <h1 className="loader-text">......</h1>
            <div className="form-template-header__can-travel">
              <p className="loader-text">......</p>
            </div>
          </div>
          <div className="form__group-wrapper">
            <div className="form-template-header__title form__group">
              <TextField
                showError={false}
                errorMessage=""
                fieldID="form_template_id"
                fieldName="..."
                fieldRequired={false}
                value="..."
                disabled
                autoComplete="off"
              />
            </div>
          </div>
          <div className="form__group-wrapper">
            <div className="form-template-header__title form__group">
              <TextField
                showError={false}
                errorMessage=""
                fieldID="form_template_id"
                fieldName="..."
                fieldRequired={false}
                value="..."
                disabled
                autoComplete="off"
              />
            </div>
          </div>
        </>
      );

    default:
      return <div />;
  }
}

export default LoadingApiPlaceholder;
